import { MembershipLevelsEnum } from "../enums/membershipLevelsEnum";

const checkQualifiedForUpgrade = (
  currentLevel: string,
  initialLevel: string
) => {
  const { MDRT, COT, TOT } = MembershipLevelsEnum;
  let qualifiedForUpgrade = false;

  switch (currentLevel) {
    case MDRT:
      qualifiedForUpgrade = false;
      break;

    case COT:
      qualifiedForUpgrade = initialLevel === MDRT;
      break;

    case TOT:
      qualifiedForUpgrade = initialLevel === MDRT || initialLevel === COT;
      break;

    default:
      break;
  }

  return qualifiedForUpgrade;
};

export default checkQualifiedForUpgrade;
